import { createTheme, type MantineColorsTuple } from '@mantine/core'

/** Petróleo: técnico y sobrio, distinto del azul corporativo por defecto. */
const petroleo: MantineColorsTuple = [
  '#e6f4f4', '#d0e6e6', '#a3cdcd', '#72b4b4', '#4c9fa0',
  '#339294', '#218a8c', '#0f777a', '#00696c', '#00595c',
]

export const tema = createTheme({
  primaryColor: 'petroleo',
  colors: { petroleo },
  defaultRadius: 'sm',
  fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  headings: { fontWeight: '650' },
  components: {
    Table: { defaultProps: { highlightOnHover: true, withTableBorder: true } },
  },
})

/** Un color por estado, consistente en toda la aplicación. */
export const COLOR_ESTADO = {
  Pendiente: 'yellow',
  Aprobado: 'teal',
  Observado: 'blue',
  Anulado: 'gray',
} as const
